/* Project finder (Homestead). Every quantity comes from the manufacturer's data sheet:
   sands from each TDS coverage table (low end of the range, so you do not run short),
   sealers and the cleaner from the Alliance Gator data sheets (one coat, per the TDS).
   Products with no published figure are still recommended where they are rated for the job,
   but no quantity is quoted for them. Live stock and prices come from /products/<handle>.js. */
(function () {
  "use strict";

  // Sands. j = rated joint width in inches [min, max]. b = coverage bands in sq ft per bag
  // (low end of the published range): [from, to, sqft, label]. mats = pavers it is rated for.
  var SANDS = [
    { k: "maxxg2", n: "Alliance Gator Maxx G2", h: "alliance-gator-maxx-g2-polymeric-sand", lb: 50, j: [0.125, 4], mats: "concrete,clay,stone",
      b: [[0.125, 0.375, 65, "narrow joints, 1/8 to 3/8 in"], [0.75, 1.25, 22, "wide joints, 3/4 to 1-1/4 in"]], mid: 22,
      bd: [[0.125, 0.375, 58], [0.75, 1.25, 20]], src: "Alliance Gator" },
    { k: "supersandg2", n: "Alliance Gator Super Sand G2", h: "alliance-gator-super-sand-g2-polymeric-sand", lb: 50, j: [0.125, 2], mats: "concrete,clay",
      b: [[0.125, 0.375, 65, "narrow joints, 1/8 to 3/8 in"], [0.75, 1.25, 22, "wide joints, 3/4 to 1-1/4 in"]], mid: 22, src: "Alliance Gator" },
    { k: "hpnextgel", n: "Techniseal HP NextGel", h: "techniseal-hp-nextgel-high-performance-polymeric-sand-50-lb-bag", lb: 50, j: [0.0625, 4], mats: "concrete,clay,stone",
      b: [[0.0625, 0.25, 60, "narrow joints"], [0.5, 4, 25, "wide joints"]], src: "Techniseal" },
    { k: "polysweep", n: "SEK PolySweep", h: "polysweep-polymeric-sand-sek-surebond-50-lb", lb: 50, j: [0.0625, 0.75], mats: "concrete,clay",
      b: [[0.0625, 0.25, 50, "joints up to 1/4 in"], [0.25, 0.5, 25, "joints 1/4 to 1/2 in"], [0.5, 0.75, 15, "joints 1/2 to 3/4 in"]], src: "SEK Surebond" },
    { k: "smartsand", n: "Techniseal SmartSand", h: "techniseal-smartsand-jointing-sand-for-interlocking-pavers", lb: 50, j: [0.0625, 1], mats: "concrete,clay",
      b: [[0.0625, 0.25, 60, "narrow joints"], [0.5, 1, 25, "wide joints"]], src: "Techniseal" },
    { k: "supersand", n: "Alliance Gator Super Sand", h: "alliance-gator-super-sand-bond-polymeric-sand", lb: 50, j: [0.125, 1], mats: "concrete,clay",
      b: [[0.125, 0.375, 65, "narrow joints, 1/8 to 3/8 in"], [0.75, 1, 22, "wide joints, 3/4 to 1 in"]], mid: 22, src: "Alliance Gator" },
    { k: "maxxbond", n: "Alliance Gator Maxx Sand", h: "alliance-gator-maxx-sand-polymeric-sand", lb: 50, j: [0.125, 2], mats: "concrete,clay",
      b: [[0.125, 0.375, 65, "narrow joints, 1/8 to 3/8 in"], [0.75, 1.25, 22, "wide joints, 3/4 to 1-1/4 in"]], mid: 22, src: "Alliance Gator" },
    { k: "simplytough", n: "SRW SimplyTough", h: "simplytough-polymeric-sand", lb: 50, j: [0.125, 0.75], mats: "concrete,clay",
      b: [[0.125, 0.25, 55, "narrow joints"], [0.5, 0.75, 25, "wide joints"]], src: "SRW" },
    { k: "ezsand35", n: "Techniseal EZ Sand", h: "techniseal-ez-sand-polymeric-jointing-sand", lb: 35, j: [0.0625, 0.5], mats: "concrete,clay",
      b: [[0.0625, 0.5, 40, "joints 1/16 to 1/2 in"]], src: "Techniseal" },
    { k: "eurostone", n: "Alliance Gator Eurostone Bond", h: "alliance-gator-eurostone-bond-polymeric-sand-natural-stone-slate-grey-50-lb", lb: 50, j: [0.125, 1.5], mats: "stone",
      b: [[0.125, 0.375, 70, "narrow joints, 1/8 to 3/8 in"], [0.75, 1.25, 24, "wide joints, 3/4 to 1-1/4 in"]], mid: 24, src: "Alliance Gator" },
    { k: "psxtreme", n: "SEK PolySweep X-Treme", h: "sek-surebond-polysweep-xtreme-wide-joint-polymeric-sand", lb: 50, j: [0.0625, 4], mats: "concrete,clay,stone",
      b: [[0.0625, 0.25, 50, "standard pavers, joints up to 1/4 in"], [0.25, 0.5, 25, "standard pavers, joints 1/4 to 1/2 in"], [2, 4, 25, "natural stone, joints 2 to 4 in", "stone"]], src: "SEK Surebond" },
    { k: "dustbond", n: "Alliance Gator Dust Bond", h: "alliance-gator-dust-bond-polymeric-stone-dust", lb: 50, j: [0.5, 6], mats: "stone",
      b: [[1, 2, 20, "stone joints, 1 to 2 in"]], src: "Alliance Gator" },
    { k: "srwxtreme", n: "SRW X-Treme", h: "x-treme-polymeric-sand-joint-up-to-6-inches-50-pound-bag", lb: 50, j: [0.25, 6], mats: "concrete,clay,stone",
      b: [[0.25, 6, 20, "joints 1/4 to 6 in"]], src: "SRW" },
    { k: "nextgelporc", n: "Techniseal NextGel Porcelain", h: "techniseal-nextgel-polymeric-sand-porcelain-tile", lb: 25, j: [0.0625, 0.5], mats: "porcelain",
      b: [[0.0625, 0.5, 80, "porcelain tile, 1/16 to 1/2 in joints"]], src: "Techniseal" }
  ];
  var ORDER = {
    concrete: ["maxxg2", "supersandg2", "hpnextgel", "polysweep", "smartsand", "supersand", "maxxbond", "simplytough", "ezsand35", "psxtreme", "srwxtreme"],
    stone: ["eurostone", "psxtreme", "dustbond", "srwxtreme", "maxxg2", "hpnextgel"],
    porcelain: ["nextgelporc"]
  };
  ORDER.clay = ORDER.concrete;

  // Sealers: Alliance Gator data sheets, one coat each. cov = sq ft per gallon (low end of the range).
  var SEALERS = {
    matte: { n: "Alliance Gator Seal Natural Look", h: "alliance-gator-seal-signature-series-natural-look", cov: 175, covTxt: "about 175 sq ft per gallon, one coat", mats: "concrete,stone" },
    satin: { n: "Alliance Gator Hybrid Seal Low Gloss", h: "alliance-gator-hybrid-seal-low-gloss-paver-sealer", cov: 100, covTxt: "100 to 225 sq ft per gallon, one coat (we used 100 so you do not run short)", mats: "concrete" },
    wet: { n: "Alliance Gator Seal Wet Look", h: "alliance-gator-seal-wet-look-paver-sealer", cov: 175, covTxt: "175 sq ft per gallon, one coat", mats: "concrete" }
  };
  // Cleaner: Gator Shampoo, 1 gallon of concentrate diluted 1:4 cleans about 375 sq ft.
  var CLEANER = { n: "Alliance Gator Shampoo", h: "alliance-gator-shampoo-concentrated-paver-cleaner", cov: 375 };

  var DISCLAIMER = "This is an estimate. Quantities use the low end of each manufacturer's published coverage, but real usage varies with paver shape, joint depth, base condition and how the product is applied. Check the product's data sheet before you start, and call (856) 418-4895 if anything does not match your job.";
  var PAVER = { patio: "patio", driveway: "driveway", pool: "pool deck", porcelain: "porcelain patio", stone: "natural stone area", repair: "repair job" };
  var MATNAME = { concrete: "concrete pavers", clay: "clay brick", porcelain: "porcelain", stone: "natural stone" };

  function fracTxt(j) { return j <= 0.125 ? '1/8"' : j <= 0.25 ? '1/4"' : j <= 0.5 ? '1/2"' : j < 2 ? '1"' : '2" or wider'; }
  function band(s, joint, material, blackDiamond) {
    var list = blackDiamond && s.bd ? s.bd.map(function (b, i) { return [b[0], b[1], b[2], s.b[i][3]]; }) : s.b;
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (b[4] && b[4] !== material) continue;
      if (joint >= b[0] && joint <= b[1]) return { sqft: b[2], label: b[3], exact: true };
    }
    // Between the narrow and wide bands (1/2 in on Alliance sheets): use the wide figure, which gives more bags.
    if (s.mid && joint > 0.375 && joint < 0.75) {
      var wide = list[list.length - 1];
      return { sqft: blackDiamond && s.bd ? s.bd[s.bd.length - 1][2] : s.mid, label: wide[3], exact: false };
    }
    return null;
  }
  function candidates(joint, material) {
    var keys = ORDER[material] || ORDER.concrete;
    var list = keys.map(function (k) { return SANDS.filter(function (s) { return s.k === k; })[0]; }).filter(function (s) {
      return s && ("," + s.mats + ",").indexOf("," + material + ",") > -1 && joint >= s.j[0] && joint <= s.j[1];
    });
    // Products with a published figure for this joint first, keeping the order above otherwise.
    var exact = function (s) { var b = band(s, joint, material); return b && b.exact; };
    var approx = function (s) { var b = band(s, joint, material); return b && !b.exact; };
    return list.filter(exact).concat(list.filter(approx)).concat(list.filter(function (s) { return !band(s, joint, material); }));
  }

  var cache = {};
  function live(handle) {
    if (!handle) return Promise.resolve(null);
    if (!cache[handle]) {
      var root = (window.PSS && window.PSS.root || "/").replace(/\/?$/, "/");
      cache[handle] = fetch(root + "products/" + encodeURIComponent(handle) + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }
    return cache[handle];
  }
  // First candidate that is actually in stock.
  function firstInStock(list) {
    var i = 0;
    function next() {
      if (i >= list.length) return Promise.resolve(null);
      var c = list[i++];
      return live(c.h).then(function (p) { return p && p.available ? { pick: c, p: p } : next(); });
    }
    return next();
  }

  function esc(s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function money(c) { return window.PSS && window.PSS.money ? window.PSS.money(c) : "$" + (c / 100).toFixed(2); }
  function gallonsIn(title) { var m = String(title).match(/(\d+(?:\.\d+)?)\s*(?:us\s*)?(?:gal|gallon)/i); return m ? Number(m[1]) : (/quart|qt/i.test(title) ? 0.25 : 1); }

  // need = units of coverage needed (bags for sand, gallons for liquids). per = how a variant converts.
  function qtyFor(v, need, kind) { if (!(need > 0)) return 0; return kind === "gal" ? Math.max(1, Math.ceil(need / gallonsIn(v.title))) : need; }
  function bestVariant(vs, need, kind) {
    if (kind !== "gal" || !(need > 0)) return vs[0];
    return vs.slice().sort(function (a, b) {
      var qa = qtyFor(a, need, kind), qb = qtyFor(b, need, kind);
      return (a.price * qa) - (b.price * qb) || qa - qb;
    })[0];
  }
  function lineTxt(v, qty, unit) {
    if (!(qty > 0)) return money(v.price) + " each · quantity not quoted";
    var u = unit === "gal" ? (gallonsIn(v.title) >= 5 ? "pail" : "jug") : unit;
    return qty + " " + u + (qty > 1 ? "s" : "") + " · " + money(v.price * qty);
  }
  function sysCard(step, p, need, kind, unit, note, emptyMsg, lb, key) {
    if (!p) return '<div class="mk-sys"><span class="mk-sys-step">' + step + '</span><p class="mk-sys-none">' + esc(emptyMsg) + "</p></div>";
    var all = p.variants;
    if (lb) {
      var re = new RegExp("(^|[^0-9.])" + lb + "\\s*(lb|lbs|pound)", "i"), sized = all.filter(function (v) { return re.test(v.title); });
      if (sized.length) all = sized;
    }
    var avail = all.filter(function (v) { return v.available; }), variants = avail.length ? avail : all;
    var v = bestVariant(variants, need, kind), qty = qtyFor(v, need, kind);
    var select = variants.length > 1 ? '<select class="mk-variant" data-sys-variant aria-label="Choose an option for ' + esc(p.title) + '">' + variants.map(function (x) {
      return '<option value="' + x.id + '" data-price="' + x.price + '"' + (x.id === v.id ? " selected" : "") + ">" + esc(x.title) + " · " + money(x.price) + "</option>";
    }).join("") + "</select>" : "";
    var img = p.featured_image ? (window.PSS && window.PSS.img ? window.PSS.img(p.featured_image, 240) : p.featured_image) : "";
    return '<div class="mk-sys" data-sys data-key="' + (key || "") + '" data-need="' + (need || 0) + '" data-kind="' + kind + '" data-unit="' + unit + '" data-qty="' + (qty || 1) + '" data-quoted="' + (qty > 0 ? 1 : 0) + '" data-variant="' + v.id + '" data-price="' + v.price + '">' +
      '<span class="mk-sys-step">' + step + '</span><a href="' + esc(p.url) + '" class="mk-thumb">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : "") + "</a>" +
      '<span><b><a href="' + esc(p.url) + '">' + esc(p.title) + '</a></b><span class="mk-spec" data-sys-line>' + lineTxt(v, qty, unit) + "</span>" +
      (note ? '<span class="mk-spec" data-sys-note>' + esc(note) + "</span>" : "") +
      (select ? '<span style="display:block;margin-top:7.2px">' + select + "</span>" : "") + "</span></div>";
  }

  function init(rootEl) {
    var ans = {}, area = 400, step = 1, steps = 5, keys = ["surface", "material", "joint", "area", "finish"];
    var q = function (s) { return rootEl.querySelector(s); }, qa = function (s) { return Array.prototype.slice.call(rootEl.querySelectorAll(s)); };
    var next = q("[data-next]"), back = q("[data-back]"), areaIn = q("[data-answer-input=area]");
    if (areaIn) area = Number(areaIn.value) || 400;
    function valid(n) { return keys[n - 1] === "area" ? area > 0 : !!ans[keys[n - 1]]; }
    function persist() { try { localStorage.setItem("pss_finder2", JSON.stringify({ ans: ans, area: area, t: Date.now() })); } catch (e) {} }
    function mark(k) { qa('[data-answer="' + k + '"]').forEach(function (x) { x.setAttribute("aria-pressed", String(x.getAttribute("data-value") === ans[k])); }); }
    function restore() {
      var saved = null;
      try { saved = JSON.parse(localStorage.getItem("pss_finder2") || "null"); } catch (e) {}
      if (!saved || !saved.ans) return false;
      Object.keys(saved.ans).forEach(function (k) { ans[k] = saved.ans[k]; mark(k); });
      if (saved.area > 0) { area = saved.area; if (areaIn) areaIn.value = saved.area; }
      return keys.every(function (k) { return k === "area" ? area > 0 : !!ans[k]; });
    }
    function draw() {
      for (var i = 1; i <= steps; i++) { var el = q('[data-step="' + i + '"]'); if (el) el.hidden = i !== step; }
      q("[data-step-label]").textContent = "Step " + step + " of " + steps;
      q("[data-progress]").style.width = (step / steps) * 100 + "%";
      back.hidden = step === 1;
      next.innerHTML = step === steps ? 'See my system <span aria-hidden="true">›</span>' : 'Continue <span aria-hidden="true">›</span>';
      next.disabled = !valid(step);
    }
    qa("[data-answer]").forEach(function (b) {
      b.addEventListener("click", function () {
        var k = b.getAttribute("data-answer");
        ans[k] = b.getAttribute("data-value");
        // Porcelain and natural stone projects answer the paver question too.
        if (k === "surface" && (ans.surface === "porcelain" || ans.surface === "stone")) { ans.material = ans.surface; mark("material"); }
        persist(); mark(k); next.disabled = false;
      });
    });
    if (areaIn) areaIn.addEventListener("input", function () { area = Number(areaIn.value) || 0; next.disabled = area <= 0; persist(); });
    next.addEventListener("click", function () { if (step < steps) { step++; draw(); } else show(); });
    back.addEventListener("click", function () { step = Math.max(1, step - 1); draw(); });

    function total() {
      var t = qa("[data-sys]").reduce(function (s, el) { return s + Number(el.getAttribute("data-price")) * Number(el.getAttribute("data-qty")); }, 0);
      q("[data-system-total]").textContent = t ? money(t) + " for the system" : "";
    }

    function show() {
      var joint = Number(ans.joint), mat = ans.material || "concrete", surface = ans.surface;
      var res = q("[data-result]"), sys = q("[data-system]");
      sys.innerHTML = '<p class="mk-sys-none">Matching products and checking live stock…</p>';
      res.hidden = false;

      // Cleaner
      var cleanerP = mat === "porcelain" ? Promise.resolve(null) : live(CLEANER.h).then(function (p) { return p && p.available ? p : null; });
      // Sand
      var sandP = firstInStock(candidates(joint, mat));
      // Sealer
      var sealer = SEALERS[ans.finish] || null, sealerMsg = "";
      if (ans.finish === "none") sealerMsg = "You chose to leave it unsealed, so nothing is added here. Polymeric sand does not need a sealer to work.";
      else if (mat === "porcelain") { sealer = null; sealerMsg = "Porcelain is non-porous and is not sealed, so nothing is added here."; }
      else if (mat === "clay") { sealer = null; sealerMsg = "The sealers we can size from a data sheet are rated for concrete pavers. For clay brick, call (856) 418-4895 and we will match a sealer to your brick."; }
      else if (sealer && ("," + sealer.mats + ",").indexOf("," + mat + ",") < 0) { sealer = null; sealerMsg = "For natural stone, the sealer in this line rated for stone is the natural look finish. Go back and pick Natural look, or call (856) 418-4895."; }
      var sealerP = sealer ? live(sealer.h).then(function (p) { return p && p.available ? p : null; }) : Promise.resolve(null);

      Promise.all([cleanerP, sandP, sealerP]).then(function (R) {
        var html = "";
        // Step 1
        var cNeed = Math.max(1, Math.ceil(area / CLEANER.cov));
        html += sysCard("Step 1 · Clean", R[0], cNeed, "gal", "gal",
          "Gator Shampoo: 1 gallon of concentrate mixed with 4 gallons of water cleans about 375 sq ft (Alliance data sheet).",
          mat === "porcelain" ? "Porcelain: clean with a pH-neutral tile cleaner before jointing. We do not size one here." : "The cleaner is out of stock right now. Call (856) 418-4895 and we will suggest another.", 0, "cleaner");
        // Step 2
        var sp = R[1], sNote = "", sNeed = 0;
        if (sp) {
          var bd = band(sp.pick, joint, mat);
          if (bd) {
            sNeed = Math.max(1, Math.ceil(area / bd.sqft));
            sNote = sp.pick.src + " data sheet: about " + bd.sqft + " sq ft per " + sp.pick.lb + " lb bag for " + bd.label + " (low end of the range)." +
              (bd.exact ? "" : " " + sp.pick.src + " publishes no figure for 1/2 in joints, so we used the wide-joint figure, which gives you a little extra.");
          } else {
            sNote = "Rated for joints up to " + fracTxt(sp.pick.j[1]).replace(" or wider", "") + ", but " + sp.pick.src + " publishes no coverage figure for joints this wide, so we will not guess a bag count. Call (856) 418-4895.";
          }
        }
        html += sysCard("Step 2 · Fill the joints", sp && sp.p, sNeed, "bag", "bag", sNote,
          "Nothing we have in stock is rated for " + fracTxt(joint) + " joints on " + MATNAME[mat] + ". Call (856) 418-4895 and we will find the right sand.", sp && sp.pick.lb, sp && sp.pick.k);
        // Step 3
        var gNeed = sealer ? Math.max(1, Math.ceil(area / sealer.cov)) : 0;
        var sealNote = sealer ? "Alliance data sheet: " + sealer.covTxt + "." + (mat === "concrete" ? " Seal new concrete pavers 60 days after installation." : "") +
          (surface === "pool" && ans.finish === "wet" ? " Around a pool a wet look finish can be slippery; the natural look is the safer choice." : "") : "";
        html += sysCard("Step 3 · Protect", R[2], gNeed, "gal", "gal", sealNote,
          sealerMsg || "That sealer is out of stock right now. Call (856) 418-4895 and we will suggest another.", 0, "sealer");
        sys.innerHTML = html;

        var sumEl = q("[data-result-summary]"), old = rootEl.querySelector("[data-result-browse]");
        if (old) old.remove();
        sumEl.textContent = area + " sq ft " + (PAVER[surface] || "project") + (surface === "porcelain" || surface === "stone" ? "" : ", " + MATNAME[mat]) + ", joints about " + fracTxt(joint) + ".";
        total();
        res.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }

    rootEl.addEventListener("change", function (e) {
      if (!e.target.hasAttribute("data-sys-variant")) return;
      var card = e.target.closest("[data-sys]"), opt = e.target.selectedOptions[0];
      var v = { id: Number(e.target.value), price: Number(opt.getAttribute("data-price")), title: opt.textContent.split(" · ")[0] };
      var kind = card.getAttribute("data-kind"), unit = card.getAttribute("data-unit"), need = Number(card.getAttribute("data-need"));
      var qty = kind === "gal" ? qtyFor(v, need, kind) : need;
      // Maxx G2 Black Diamond covers less than the other colors.
      if (card.getAttribute("data-key") === "maxxg2" && need > 0) {
        var s = SANDS[0], bd = band(s, Number(ans.joint), ans.material || "concrete", /black/i.test(v.title));
        if (bd) {
          qty = Math.max(1, Math.ceil(area / bd.sqft));
          var nEl = card.querySelector("[data-sys-note]");
          if (nEl) nEl.textContent = "Alliance Gator data sheet: about " + bd.sqft + " sq ft per 50 lb bag for " + bd.label + (/black/i.test(v.title) ? " in Black Diamond, which covers a little less than the other colors." : " (low end of the range).");
        }
      }
      card.setAttribute("data-variant", v.id); card.setAttribute("data-price", v.price);
      if (qty > 0) card.setAttribute("data-qty", qty);
      var ln = card.querySelector("[data-sys-line]");
      if (ln) ln.textContent = lineTxt(v, card.getAttribute("data-quoted") === "1" ? qty : 0, unit);
      total();
    });

    var addAll = q("[data-add-system]");
    if (addAll) addAll.addEventListener("click", function () {
      var items = qa("[data-sys]").map(function (el) { return { id: Number(el.getAttribute("data-variant")), quantity: Number(el.getAttribute("data-qty")) || 1 }; });
      if (!items.length || !window.PSS) return;
      var html = addAll.innerHTML; addAll.disabled = true;
      window.PSS.add(items).then(function () {
        addAll.innerHTML = "&#10003; System added to cart";
        window.PSS.toast({ title: items.length + " products added from your recommended system" });
        setTimeout(function () { addAll.innerHTML = html; addAll.disabled = false; }, 2200);
      }).catch(function (err) { addAll.disabled = false; window.PSS.toast({ error: true, title: err.message }); });
    });
    var restart = q("[data-restart]");
    if (restart) restart.addEventListener("click", function () {
      step = 1; Object.keys(ans).forEach(function (k) { delete ans[k]; });
      qa("[data-answer]").forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
      q("[data-result]").hidden = true; draw(); rootEl.scrollIntoView({ behavior: "smooth", block: "start" });
    });
    if (restore() && !q("[data-resume]")) {
      var rb = document.createElement("div");
      rb.className = "mk-finder-resume"; rb.setAttribute("data-resume", "");
      rb.innerHTML = '<span>Welcome back. Your answers from last time are still here.</span><button type="button" class="mk-cta mk-cta-quiet">Show my system again</button>';
      rb.querySelector("button").addEventListener("click", function () { show(); });
      var host = q('[data-step="1"]') || rootEl; host.parentNode.insertBefore(rb, host);
    }
    var disc = q("[data-disclaimer]");
    if (disc) disc.textContent = DISCLAIMER;
    draw();
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll("[data-finder-root]"), function (el) { if (!el.__pss) { el.__pss = 1; init(el); } }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
  document.addEventListener("shopify:section:load", boot);
})();
